import { render } from "./CaptureSelector.vue?vue&type=template&id=05460088&scoped=true"
import script from "./CaptureSelector.vue?vue&type=script&lang=js"
export * from "./CaptureSelector.vue?vue&type=script&lang=js"

import "./CaptureSelector.vue?vue&type=style&index=0&id=05460088&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05460088"]])

export default __exports__